import React from 'react';
import styles from './box.module.scss';

type Props = {
    children: any
};

export const Box: React.FunctionComponent<Props> = (props: Props) => {
    return (
        <div className={styles.box}>
            {props.children}
        </div>
    );
};
